// The file "hosting" the proxy on the webstore side

const debug = require('debug')('plugin:server');
const Server = require('./lib/PluginClient');
const domready = require('domready');
const { initCsrfBootstrap } = require('public/js/lib/csrf/bootstrap');

// Polyfills
require('core-js/fn/array/includes');
require('core-js/fn/object/assign');

(function (doc, win) {
	'use strict';

	domready(() => {
		debug('domready');
		initCsrfBootstrap();
		new Server({window: win, clientWindow: win.top, env: {}});
	});
}(document, window));
